import { gql } from "@apollo/client";

export const EMAIL_CLOSE = gql`
  mutation emailClose($id: Int!) {
    emailClose(id: $id) {
      id
      message
      isError
    }
  }
`;
